import React from 'react';

function Footer() {
    return (
        <div id="global-footer">
            <p>
                <a href="https://omceg.freshservice.com/support/catalog/items" target="_blank" rel="noreferrer">Need Help?</a>
                <span>&copy; GMR</span>
            </p>
        </div>
    );
}

export default Footer;